export const timeFormatter = (val: string | null | undefined, emptyVal = "") =>
	val ? val.slice(0, -3) : emptyVal;
